module.exports = __webpack_public_path__ + "media/mascot/mascot3-2eb2e30e.png";